import { apiSlice } from "../api/apiSlice";

export const projectApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProjects: builder.query({
      query: (category) => `/projects?category_like=${category}`,
    }),
    createProject: builder.mutation({
      query: (data) => ({
        url: "/projects",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const project = await queryFulfilled;
        if (project) {
          dispatch(
            apiSlice.util.updateQueryData(
              "getProjects",
              project?.data.category,
              (draft) => {
                draft.push(project?.data);
              }
            )
          );
        }
      },
    }),
    deleteProject: builder.mutation({
      query: (id) => ({
        url: `/projects/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const project = await queryFulfilled;
        if (project) {
          dispatch(
            apiSlice.util.updateQueryData("getProjects", "Backlog", (draft) => {
              return draft.filter((p) => p.id !== arg);
            })
          );
        }
      },
    }),
  }),
});

export const {
  useCreateProjectMutation,
  useGetProjectsQuery,
  useDeleteProjectMutation,
} = projectApi;
